import { defaultCommonValues } from '../flags';
import useConfig from './useConfig';

const useCommonConfig = attributes => useConfig(attributes, defaultCommonValues, 'commonConfig');

export default useCommonConfig;
